
import flatpickr from "flatpickr";
import * as bootstrap from 'bootstrap'
import "../../../../node_modules/virtual-select-plugin/dist/virtual-select.min.js"
import "../../../../node_modules/virtual-select-plugin/dist/virtual-select.min.css";

import "@splidejs/splide/dist/css/splide.min.css";
import "flatpickr/dist/flatpickr.min.css";



//import "../../../../node_modules/nice-select2/dist/js/nice-select2.js"




//NiceSelect.bind(document.getElementById("#a-select"));


VirtualSelect.init({ ele: '.virtual-select', search:true, selectAllOnlyVisible:true,autoSelectFirstOption:false, noSearchResultsText:"Aucun résultat", searchPlaceholderText: "Rechercher", selectAllText:'Tout sélectionner',allOptionsSelectedText: 'Tous', optionsSelectedText:'options choisies'});


import './app.scss';


import './components/layout/layout.scss';
const layout = require( './components/layout/layout' );
layout.init();

import './components/front-page/front-page.scss';
const frontPage = require( './components/front-page/front-page' );
frontPage.init();

import './components/page-cms/page-cms.scss';
const pageCms = require( './components/page-cms/page-cms' );
pageCms.init();

import './components/contact/contact.scss';
const contact = require( './components/contact/contact' );
contact.init();

import './components/destination/destination.scss';
var destination = require( './components/destination/destination' );
destination.init();

import './components/various-content/various-content.scss';
var various = require( './components/various-content/various-content' );
various.init();



